import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { useDeleteConfirmationModalStore } from "../../../../store/useDeleteConfirmationModalStore";

import Button from "@semcore/button";
import Spin from "@semcore/spin";
import CheckM from "@semcore/icon/Check/m";
import CloseM from "@semcore/icon/Close/m";

export default function DeleteModalDialog() {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const {
    isDeleteModalOpen,
    deleteMessage,
    onDeleteConfirm,
    closeDeleteModal,
    isDeleteModalLoading,
    confirmButtonText,
  } = useDeleteConfirmationModalStore();

  if (!isDeleteModalOpen) return null;

  const handleConfirm = async () => {
    onDeleteConfirm();
  };

  return (
    <React.Fragment>
      <Dialog
        fullScreen={fullScreen}
        open={isDeleteModalOpen}
        onClose={closeDeleteModal}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">Are you sure?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {deleteMessage || "Do you want to delete this item?"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDeleteModal}>
            <Button.Addon>
              <CloseM size="xs" />
            </Button.Addon>
            <Button.Text>Close</Button.Text>
          </Button>
          <Button onClick={handleConfirm} disabled={isDeleteModalLoading}>
            <Button.Addon>
              {isDeleteModalLoading ? <Spin size="xs" /> : <CheckM size="xs" />}
            </Button.Addon>
            <Button.Text>
              {isDeleteModalLoading ? "Loading" : confirmButtonText}
            </Button.Text>
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
